import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { KONTAKT } from "../config/kontakt";
import { useAuth } from "../context/AuthContext";
import { api } from "../api/api";

export default function Startseite() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [urlaube, setUrlaube] = useState([]);
  const [events,  setEvents]  = useState([]);
  const [news,    setNews]    = useState([]);  // kept for future use

  useEffect(() => {
    api.betriebsurlaub.getAll().then(setUrlaube).catch(() => {});
    api.events.getAll().then(evs => setEvents(evs.filter(e => e.istAktiv))).catch(() => {});
    api.news.getAll(true).then(setNews).catch(() => {});
  }, []);

  // Aktueller oder nächster Betriebsurlaub
  const heute = new Date();
  heute.setHours(0, 0, 0, 0);

  const aktuellerUrlaub = urlaube.find(u => {
    const von = new Date(u.urlaubVon);
    const bis = new Date(u.urlaubBis);
    return heute >= von && heute <= bis;
  });

  const naechsterUrlaub = urlaube.find(u => {
    const von = new Date(u.urlaubVon);
    const tage = Math.ceil((von - heute) / (1000 * 60 * 60 * 24));
    return tage > 0 && tage <= 30;
  });

  const handleShopClick = (e) => {
    if (!user) {
      e.preventDefault();
      // Modal öffnen geht nicht direkt – zur Startseite scrollen mit Hinweis
      document.getElementById("anmelden-hinweis")?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/profil");
    }
  };

  return (
    <>
      <div className="hero">
        <h1>🐄 Willkommen bei Milchhof Gehrke</h1>
        <p>Frische Milchprodukte direkt vom Bauernhof – natürlich, regional, lecker.</p>
        <Link to="/produkte" className="btn btn-primary" style={{ fontSize: "1.3rem", padding: "1rem 2.5rem" }}>
          Unsere Produkte
        </Link>
      </div>

      <div className="container">

        {aktuellerUrlaub && (
          <div style={{
            marginTop: "1.5rem",
            background: "#ede7f6",
            border: "2px solid #9c27b0",
            borderRadius: "12px",
            padding: "1.25rem 1.5rem",
            display: "flex", alignItems: "center", gap: "1rem"
          }}>
            <span style={{ fontSize: "2rem" }}>🏖️</span>
            <div>
              <strong style={{ color: "#6a1b9a", fontSize: "1.1rem" }}>Wir sind im Betriebsurlaub!</strong>
              <p style={{ color: "#7b1fa2", margin: "0.2rem 0 0" }}>
                Vom {new Date(String(aktuellerUrlaub.urlaubVon).slice(0,10) + "T00:00:00").toLocaleDateString("de-DE")} bis {new Date(String(aktuellerUrlaub.urlaubBis).slice(0,10) + "T00:00:00").toLocaleDateString("de-DE")} sind wir nicht erreichbar.
                {aktuellerUrlaub.beschreibung && ` (${aktuellerUrlaub.beschreibung})`}
              </p>
            </div>
          </div>
        )}

        {!aktuellerUrlaub && naechsterUrlaub && (
          <div style={{
            marginTop: "1.5rem",
            background: "#fff3e0",
            border: "2px solid #ff9800",
            borderRadius: "12px",
            padding: "1rem 1.5rem",
            display: "flex", alignItems: "center", gap: "1rem"
          }}>
            <span style={{ fontSize: "1.5rem" }}>📅</span>
            <div>
              <strong style={{ color: "#e65100" }}>Bald Betriebsurlaub</strong>
              <p style={{ color: "#bf360c", margin: "0.2rem 0 0", fontSize: "0.95rem" }}>
                Vom {new Date(String(naechsterUrlaub.urlaubVon).slice(0,10) + "T00:00:00").toLocaleDateString("de-DE")} bis {new Date(String(naechsterUrlaub.urlaubBis).slice(0,10) + "T00:00:00").toLocaleDateString("de-DE")}.
                {naechsterUrlaub.beschreibung && ` (${naechsterUrlaub.beschreibung})`}
              </p>
            </div>
          </div>
        )}

        {/* ── Shop CTA + Kontakt ── */}
        <div className="grid-2col" style={{ marginTop: "2.5rem" }}>

          {/* Karte 1: Shop */}
          <div style={{
            background: "linear-gradient(135deg, #e8f5e9, #c8e6c9)",
            borderRadius: "16px", padding: "2.5rem 2rem",
            textAlign: "center", border: "2.5px solid #66bb6a",
            boxShadow: "0 4px 16px rgba(46,125,50,0.15)",
            display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
          }}>
            <div style={{ fontSize: "3rem", marginBottom: "0.5rem" }}>🛒</div>
            <h2 style={{ fontSize: "1.75rem", color: "#1b5e20", marginBottom: "0.75rem" }}>
              Jetzt frisch bestellen!
            </h2>
            <p style={{ color: "#388e3c", fontSize: "1rem", marginBottom: "2rem" }}>
              Milch, Kakao & mehr – direkt vom Hof zu Ihnen nach Hause.
            </p>

            {user ? (
              <Link to="/profil" style={{
                display: "inline-block", background: "#2e7d32", color: "white",
                textDecoration: "none", fontSize: "1.1rem", fontWeight: "700",
                padding: "0.9rem 2.5rem", borderRadius: "50px",
                boxShadow: "0 4px 14px rgba(46,125,50,0.4)",
              }}>
                🛍️ Zum Shop
              </Link>
            ) : (
              <div id="anmelden-hinweis" style={{ width: "100%", maxWidth: 380 }}>
                {/* Neukunde */}
                <div style={{
                  background: "white", borderRadius: "12px", padding: "1rem 1.25rem",
                  marginBottom: "1rem", border: "1.5px solid #a5d6a7",
                }}>
                  <p style={{ color: "#1b5e20", fontWeight: 700, margin: "0 0 0.3rem", fontSize: "0.95rem" }}>
                    🆕 Neu hier?
                  </p>
                  <p style={{ color: "#555", fontSize: "0.88rem", margin: "0 0 0.85rem" }}>
                    Registrieren Sie sich, um Bestellungen aufzugeben.
                  </p>
                  <Link
                    to="/produkte"
                    style={{
                      display: "block", background: "#2e7d32", color: "white",
                      textAlign: "center", textDecoration: "none",
                      fontSize: "1rem", fontWeight: "700",
                      padding: "0.75rem 1.5rem", borderRadius: "50px",
                      boxShadow: "0 4px 14px rgba(46,125,50,0.35)",
                    }}>
                    📋 Registrieren
                  </Link>
                </div>
                {/* Bestandskunde */}
                <div style={{ textAlign: "center" }}>
                  <span style={{ color: "#388e3c", fontSize: "0.9rem" }}>Bereits Kunde? </span>
                  <button
                    onClick={() => window.dispatchEvent(new CustomEvent("open-auth-modal"))}
                    style={{
                      background: "none", border: "none", cursor: "pointer",
                      color: "#2e7d32", fontWeight: 700, fontSize: "0.9rem",
                      textDecoration: "underline", padding: 0,
                    }}>
                    Jetzt anmelden
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Karte 2: Kontakt & Öffnungszeiten */}
          <div style={{
            background: "linear-gradient(135deg, #fff8e1, #fff3cd)",
            borderRadius: "16px", padding: "2.5rem 2rem",
            border: "2.5px solid #ffc107",
            boxShadow: "0 4px 16px rgba(255,193,7,0.15)",
          }}>
            <div style={{ fontSize: "2.5rem", marginBottom: "0.5rem" }}>📞</div>
            <h2 style={{ fontSize: "1.5rem", color: "#e65100", marginBottom: "1.25rem" }}>
              Kontakt & Öffnungszeiten
            </h2>

            <div style={{ marginBottom: "1.25rem" }}>
              <div style={{ fontWeight: 700, color: "#333", marginBottom: "0.25rem" }}>📱 Telefon</div>
              <div style={{ color: "#555", fontSize: "1rem" }}>{KONTAKT.telefon}</div>
            </div>

            <div style={{ marginBottom: "1.25rem" }}>
              <div style={{ fontWeight: 700, color: "#333", marginBottom: "0.5rem" }}>🏢 Bürozeiten</div>
              <table style={{ fontSize: "0.95rem", color: "#555", borderCollapse: "collapse" }}>
                <tbody>
                  <tr><td style={{ paddingRight: "1.5rem", paddingBottom: "0.2rem" }}>Mo – Fr</td><td>07:30 – 11:30 Uhr</td></tr>
                  <tr><td style={{ paddingRight: "1.5rem" }}>Sa / So</td><td>geschlossen</td></tr>
                </tbody>
              </table>
            </div>

            <div>
              <div style={{ fontWeight: 700, color: "#333", marginBottom: "0.25rem" }}>✉️ E-Mail</div>
              <div style={{ color: "#555", fontSize: "0.95rem" }}>{KONTAKT.email}</div>
            </div>
          </div>

        </div>

        {/* ── Events ── */}
        {events.length > 0 && (
          <div style={{ marginTop: "2.5rem" }}>
            <h2 style={{ color: "#e65100", marginBottom: "1rem" }}>🎉 Kommende Veranstaltungen</h2>
            <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
              {events.map(e => {
                const datum = e.datum ? new Date(String(e.datum).slice(0, 10) + "T00:00:00") : null;
                const tag   = datum && !isNaN(datum) ? datum.getDate() : "?";
                const monat = datum && !isNaN(datum) ? datum.toLocaleDateString("de-DE", { month: "short" }) : "–";
                return (
                <div key={e.eventId} className="card" style={{
                  border: "1.5px solid #ffcc80",
                  display: "flex", alignItems: "center", gap: "1.25rem"
                }}>
                  <div style={{
                    background: "linear-gradient(135deg, #e65100, #ff9800)",
                    color: "white", borderRadius: "12px", padding: "0.6rem 0.9rem",
                    textAlign: "center", flexShrink: 0, minWidth: 60
                  }}>
                    <div style={{ fontSize: "1.4rem", fontWeight: 700, lineHeight: 1 }}>{tag}</div>
                    <div style={{ fontSize: "0.75rem", textTransform: "uppercase", opacity: 0.9 }}>{monat}</div>
                  </div>
                  <div style={{ flex: 1 }}>
                    <strong style={{ color: "#e65100", fontSize: "1.05rem" }}>{e.titel}</strong>
                    <div style={{ color: "#666", fontSize: "0.88rem", marginTop: "0.2rem" }}>
                      {e.uhrzeit && `🕐 ${e.uhrzeit} Uhr`}
                      {e.uhrzeit && e.ort && " · "}
                      {e.ort && `📍 ${e.ort}`}
                    </div>
                    {e.beschreibung && <p style={{ color: "#888", fontSize: "0.88rem", margin: "0.2rem 0 0" }}>{e.beschreibung}</p>}
                  </div>
                </div>
                );
              })}
            </div>
          </div>
        )}

        {/* ── Info Cards ── */}
        <div className="card-grid" style={{ marginTop: "2.5rem" }}>

          {/* Kachel 1: EU-Logo */}
          <a href="https://www.ml.niedersachsen.de/startseite/themen/eu_forderung_zur_entwicklung_im_landlichen_raum/eu-foerderung-in-niedersachsen-147111.html" target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
          <div className="card" style={{ border: "1.5px solid #003399", padding: "1.25rem", display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", gap: "0.75rem", cursor: "pointer" }}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 810 540" width="120" height="80">
              <rect width="810" height="540" fill="#003399"/>
              {Array.from({ length: 12 }, (_, i) => {
                const angle = (i * 30 - 90) * Math.PI / 180;
                const cx = 405 + 162 * Math.cos(angle);
                const cy = 270 + 162 * Math.sin(angle);
                return (
                  <polygon key={i}
                    points="0,-18 4.9,-6.2 18,-6.2 7.3,3.8 11.1,17 0,8 -11.1,17 -7.3,3.8 -18,-6.2 -4.9,-6.2"
                    fill="#FFDD00"
                    transform={`translate(${cx},${cy})`}
                  />
                );
              })}
            </svg>
            <div style={{ fontWeight: 700, fontSize: "0.85rem", color: "#003399", letterSpacing: "0.03em" }}>
              EUROPÄISCHE UNION
            </div>
            <div style={{ fontSize: "0.72rem", color: "#444", lineHeight: 1.4 }}>
              Europäischer Landwirtschaftsfonds für<br />
              die Entwicklung des ländlichen Raums – ELER
            </div>
            <div style={{ fontSize: "0.72rem", fontWeight: 700, color: "#333" }}>
              Hier investiert Europa in die ländlichen Gebiete
            </div>
          </div>
          </a>

          {/* Kachel 2: Schulmilchprogramm */}
          <div className="card" style={{ border: "1.5px solid #003399", padding: "1.25rem", display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", gap: "0.75rem" }}>
            <div style={{ fontWeight: 700, fontSize: "1.1rem", color: "#003399" }}>🏫 Schulmilchprogramm</div>
            <div style={{ fontSize: "0.88rem", color: "#555", lineHeight: 1.6 }}>
              Frische Milch für Schulkinder – gefördert durch die Europäische Union.
            </div>
            <Link
              to="/schulmilch"
              style={{
                display: "inline-block",
                background: "#00aaff",
                color: "white",
                fontWeight: 600,
                fontSize: "0.88rem",
                padding: "0.5rem 1rem",
                borderRadius: "6px",
                textDecoration: "none",
                border: "2px solid #003399",
                marginTop: "auto",
              }}>
              Jetzt anmelden
            </Link>
          </div>

          {/* Kachel 3: Betriebsurlaub */}
          <div className="card" style={{ border: "1.5px solid #9c27b0", padding: "1.25rem", display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", gap: "0.75rem" }}>
            <div style={{ fontWeight: 700, fontSize: "1.1rem", color: "#6a1b9a" }}>🏖️ Betriebsurlaub</div>
            <div style={{ fontSize: "0.88rem", color: "#555", lineHeight: 1.6 }}>
              Informationen zu unseren geplanten Betriebsferien und Schließzeiten.
            </div>
            <Link
              to="/betriebsurlaub"
              style={{
                display: "inline-block",
                background: "#6a1b9a",
                color: "white",
                fontWeight: 600,
                fontSize: "0.88rem",
                padding: "0.5rem 1rem",
                borderRadius: "6px",
                textDecoration: "none",
                border: "2px solid #4a148c",
                marginTop: "auto",
              }}>
              Mehr erfahren
            </Link>
          </div>

        </div>

      </div>
    </>
  );
}
